var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page webview-page"},[_c('Menus',{attrs:{"title":_vm.title,"home":true}}),_c('div',{staticClass:"container-flex"},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }